"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LineChart;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactGoogleCharts = require("react-google-charts");
var _reactIntl = require("react-intl");
var _utils = require("../../utils");
var _excluded = ["chartContainerClassName", "colors", "containerClassName", "data", "id", "lengendContainerClassName", "noResultsTranslationKey", "options"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    chart: {
      '& text': {
        fill: theme.palette.text.secondary
      },
      '@global': {
        'g > g > path[fill="#ffffff"]': {
          fill: theme.palette.background.default
        }
      },
      height: 400
    },
    legend: {
      marginBottom: theme.spacing(-2),
      marginTop: theme.spacing(2),
      zIndex: 1
    },
    noResults: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      minHeight: 200
    }
  };
});
function LineChart(_ref) {
  var _FormattedMessage;
  var chartContainerClassName = _ref.chartContainerClassName,
    colors = _ref.colors,
    containerClassName = _ref.containerClassName,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    id = _ref.id,
    lengendContainerClassName = _ref.lengendContainerClassName,
    _ref$noResultsTransla = _ref.noResultsTranslationKey,
    noResultsTranslationKey = _ref$noResultsTransla === void 0 ? 'chart.noResults' : _ref$noResultsTransla,
    options = _ref.options,
    other = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)((data == null ? void 0 : data[0]) && Array.isArray(data[0]) && data[0].map(function (filter) {
      return filter;
    }) || []),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    effectiveFilters = _useState2[0],
    setEffectiveFilters = _useState2[1];
  var classes = useStyles();
  var theme = (0, _material.useTheme)();
  var intl = (0, _reactIntl.useIntl)();
  if (!data || !(data.length >= 2) || !data[0] || !(data[0].length >= 2)) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.noResults,
      id: id
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      id: "".concat(id, "NoResults"),
      variant: "body1"
    }, _FormattedMessage || (_FormattedMessage = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: noResultsTranslationKey
    }))));
  }
  var filters = data[0].slice(1, data[0].length) || [];
  var colorMap = filters.reduce(function (map, filter, i) {
    return (0, _extends2.default)(map, {
      /**
       *  "i * 3" guarantees that colors will be different from each other
       *  "+ 63" is the offset to start with the darker colors
       */
      [filter]: (colors == null ? void 0 : colors[filter]) || _utils.COLORS[(i * 3 + 63) % _utils.COLORS.length]
    });
  }, {});
  var seriesColors = filters.filter(function (filter) {
    return effectiveFilters.includes(filter);
  }).map(function (filter) {
    return colorMap[filter];
  });
  var filteredColumnsIndexes = data[0].filter(function (colName) {
    return effectiveFilters.includes(colName);
  }).map(function (colName) {
    return data[0].indexOf(colName);
  });
  var filteredData = data.map(function (row) {
    return row.filter(function (col, i) {
      return filteredColumnsIndexes.includes(i);
    });
  });
  var displayedData = [filteredData[0].map(function (title) {
    return intl.formatMessage({
      defaultMessage: title,
      id: "chart.".concat(title)
    });
  })].concat((0, _toConsumableArray2.default)(filteredData.slice(1, filteredData.length)));
  var toggleFilter = function toggleFilter(filter) {
    if (effectiveFilters.includes(filter) && effectiveFilters.length > 2) {
      setEffectiveFilters(effectiveFilters.filter(function (f) {
        return f !== filter;
      }));
    } else if (!effectiveFilters.includes(filter)) {
      setEffectiveFilters(effectiveFilters.concat(filter));
    }
  };
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: containerClassName,
    container: true,
    id: id,
    spacing: 2
  }, !!displayedData.length && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: (0, _classnames.default)(classes.legend, lengendContainerClassName),
    id: "".concat(id, "LineChartLegendContainer"),
    item: true,
    xs: 12
  }, filters.map(function (filter, i) {
    return /*#__PURE__*/_react.default.createElement(_material.Chip, {
      key: filter,
      id: "".concat(id, "LineChartLegend").concat(i),
      label: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        defaultMessage: filter,
        id: "chart.".concat(filter)
      }),
      onClick: function onClick() {
        return toggleFilter(filter);
      },
      style: {
        backgroundColor: effectiveFilters.includes(filter) && colorMap[filter],
        color: theme.palette.common.white
      }
    });
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: (0, _classnames.default)(classes.chart, chartContainerClassName),
    id: "".concat(id, "LineChartContainer"),
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_reactGoogleCharts.Chart, (0, _extends2.default)({
    chartType: "LineChart",
    data: displayedData,
    height: "400px",
    id: "".concat(id, "LineChart"),
    options: (0, _utils.mergeDeep)({
      backgroundColor: theme.palette.background.paper,
      chartArea: {
        width: '80%'
      },
      colors: seriesColors,
      fontName: 'Roboto',
      hAxis: {
        // X axis
        gridlines: {
          color: 'transparent',
          units: {
            months: {
              format: 'MMM, yyyy'
            }
          }
        },
        minorGridlines: {
          units: {
            days: {
              format: ''
            },
            hours: {
              format: ''
            },
            milliseconds: {
              format: ''
            },
            minutes: {
              format: ''
            },
            months: {
              format: ''
            },
            seconds: {
              format: ''
            },
            year: {
              format: ''
            }
          }
        },
        titleTextStyle: {
          fontSize: 12,
          italic: false
        }
      },
      legend: 'none',
      lineWidth: 3,
      pointSize: 5,
      vAxis: {
        // Y axis
        baselineColor: theme.palette.grey[400],
        minValue: 1,
        titleTextStyle: {
          fontSize: 12,
          italic: false
        }
      }
    }, options || {}),
    width: "100%"
  }, other)))));
}
LineChart.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.array).isRequired
};